export enum Type {
  TEST_TRACKER = 'test_tracker',
}
export interface Options
  extends Record<Type, { [key: string]: string | number | boolean }> {
  [Type.TEST_TRACKER]: {
    value: string;
  };
}
